class Search {

    constructor(nodelist) {
        this.buttons = nodelist;
        this.overlay = document.querySelector('.search');
        this.form    = this.overlay.querySelector('form');
        this.input   = this.overlay.querySelector('input');
    }


    initOpenOverlay() {

        this.buttons.forEach(element => {
            element.addEventListener('click', (event) => {
                this.overlay.classList.add('active');
                this.input.focus();
            })
        });
    }


    initCloseOverlay() {
        
        this.overlay.addEventListener('click', (event) => {
            this.overlay.classList.remove('active');
        })

        this.form.addEventListener('click', (event) => {
            event.stopPropagation();
        })
    }


    init() {

        this.initOpenOverlay();
        this.initCloseOverlay();
    }
}


const initSearch = (nodelist) => {

    const searchButtons = new Search(nodelist);
    searchButtons.init();
}

export default initSearch;